import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The mountains are beautiful magnificent beasts",
  "description": "",
  "published": "2010-07-26T00:00:00.000Z",
  "redirect_from": ["/blog/the-mountains-are-beautiful-magnificent-beasts/swizec/1401"],
  "categories": "Hiking, life, Mountain, Outdoors, Recreation, Tourism, Trail, travel, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday I finally managed to take that `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Hiking",
        "title": "Hiking"
      }}>{`hiking`}</a>{` trip I've been meaning to for months.`}</p>
    <p>{`And it was fucking awesome!`}</p>
    <p>{`We went to something called `}<a parentName="p" {...{
        "href": "http://www.hribi.net/gora/vodotocno_jezero_veza/3/288"
      }}>{`Vodotocno jezero`}</a>{` - a small `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Mountain",
        "title": "Mountain"
      }}>{`mountain`}</a>{` puddle really. But it was beautiful anyway. The trip started off with a long and bloody awesome drive. I like driving around tight `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Gravel",
        "title": "Gravel"
      }}>{`gravel`}</a>{` curves and making the car drift without using the handbrake. :P`}</p>
    <p>{`When we got to the starting point it was hellishly cold. Probably less than 10C. Luckily for Girlfriend the backpack I was carrying contained some forgotten gloves. After a short wall some really lovely views opened up from a small and funny shepherd's cottage thingy.`}</p>
    <p>{`Then the real hike began. First there was a little steepness through a bit of a forest and after that a very nice and unsteep path across some hillsides with such a magnificently awesome view I almost shat my pants.`}</p>
    <p>{`But the real fun began once we got off the marked `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Trail",
        "title": "Trail"
      }}>{`trails`}</a>{` and just winged it across the terrain. Some grass here, a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Rock_music",
        "title": "Rock music"
      }}>{`rock`}</a>{` there and those weird short `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Pine",
        "title": "Pine"
      }}>{`pine`}</a>{` things that grow up in the high mountains because trees can't. Sure we almost got lost once we were near the saddle between to summits and we couldn't quite discern where it was anymore but meh.`}</p>
    <p>{`Eventually the view onto the small puddle and cottage next to it opened up and it was plain sailing therefrom. Well no, no it was not. Girlfriend twisted her ankle and what was supposed to be the final ten minutes before reaching the destination turned into a thirty minute painful weirdness. Turns out hoping rock to loose rock on a steep steep hill with a twisted ankle isn't at all an easy task.`}</p>
    <p>{`The trip back was even cunner. Took us something like three hours getting back to the car and we got a little bit lost so we took a nicely more dangerous path to get down than w did for getting up. Hoorah!`}</p>
    <p>{`But hey, fuck it. I'm just incredibly choked that the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Global_Positioning_System",
        "title": "Global Positioning System"
      }}>{`GPS`}</a>{` data later showed that saddle was 2004 meters high and I don't think I've ever walked anywhere near that high before. Was awesome!`}</p>
    <p>{`Therefore, some pics.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_FFB489E9-7FD2-4E9D-8A75-7F69964878DD.jpeg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_FFB489E9-7FD2-4E9D-8A75-7F69964878DD.jpeg",
          "alt": null
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_6D6880BA-1CB1-4A8C-ADAF-405C28C592AC.jpeg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_6D6880BA-1CB1-4A8C-ADAF-405C28C592AC.jpeg",
          "alt": null
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_9A770133-F516-473B-AD52-122F6D3451F4.jpeg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_9A770133-F516-473B-AD52-122F6D3451F4.jpeg",
          "alt": null
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_77873199-4A7A-4FA5-AAD0-17FBE163B039.jpeg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_77873199-4A7A-4FA5-AAD0-17FBE163B039.jpeg",
          "alt": null
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_F77F4C04-C5E3-461E-9969-EBDED8BEC833.jpeg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_F77F4C04-C5E3-461E-9969-EBDED8BEC833.jpeg",
          "alt": null
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_15167C8F-D294-4688-8C00-44F8AF9B84A2.jpeg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_15167C8F-D294-4688-8C00-44F8AF9B84A2.jpeg",
          "alt": null
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_4A52AA59-5C29-4ABD-B0B6-01F57F9736ED.jpeg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_4A52AA59-5C29-4ABD-B0B6-01F57F9736ED.jpeg",
          "alt": null
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_12ABBB3A-7507-4E33-96FD-6DFFAB675883.jpeg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/07/l_2044_1536_12ABBB3A-7507-4E33-96FD-6DFFAB675883.jpeg",
          "alt": null
        }}></img></a></p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=5288279a-04df-4383-ba01-69b7586c769d",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      